export default __webpack_public_path__ + "static/Logotype-ff226d210726aca3f2c1e305acb2be2e.svg";